import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import IconWrapper from './IconWrapper'

const PhoneIcon = ({ color, width, height, display, ...rest }) => (
  <IconWrapper width={width} height={height} display={display}>
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <g fill="none" fillRule="evenodd">
        <path fill="none" d="M0 0h32v32H0z" fillOpacity="0" />
        <path
          d="M26.458 20.36c-.59-.291-3.494-1.7-4.036-1.9-.542-.201-.935-.293-1.328.291-.394.584-1.526 1.896-1.87 2.286-.345.389-.69.437-1.28.145-.59-.292-2.493-.907-4.75-2.893-1.755-1.546-2.946-3.454-3.286-4.038-.34-.584-.036-.895.26-1.19.265-.261.59-.68.885-1.022.294-.34.394-.583.59-.972.196-.39.099-.73-.049-1.021-.147-.292-1.33-3.161-1.82-4.328-.48-1.137-.967-.983-1.33-1.007a24.11 24.11 0 00-1.132-.02 2.182 2.182 0 00-1.576.73c-.54.583-2.066 1.993-2.066 4.862 0 2.87 2.116 5.641 2.41 6.03.295.39 4.166 6.277 10.087 8.803 1.1.468 2.224.879 3.367 1.23 1.415.448 2.702.382 3.72.232 1.133-.168 3.494-1.41 3.987-2.772.493-1.361.492-2.529.34-2.772-.152-.242-.533-.377-1.123-.669v-.004z"
          stroke={color}
        />
      </g>
    </svg>
  </IconWrapper>
)

PhoneIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  display: PropTypes.string,
}

PhoneIcon.defaultProps = {
  color: theme.colors.coaldark,
  width: '32px',
  height: '32px',
  display: 'block',
}

export default PhoneIcon
